import React, {useState} from 'react';
import OKSvg from "../../img/ok-svgrepo-com.svg";
import {addDevidersToString} from "./helper-functions";
import {useNavigate} from "react-router-dom";



const CardViewerTable = ({
                             store, sortedCards, setQrData, setQrName, setActiveModalQr, startCardTest,
                             processing, setCardToDelete, setCardToUnbind, setActiveModalConfirm, setModalMessage,
                             activateCardWithoutTest, changeCardStatus
}) => {



    const navigate = useNavigate()

    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopy = (cardId, index) => {
        navigator.clipboard.writeText(cardId);
        setCopiedIndex(index);
        // setTimeout(() => setCopiedIndex(null), 2000); // Возвращаем текст обратно через 2 секунды
    };


    return (
        <table className="transaction-table">
            <thead>
            <tr>
                {store.user.roles.includes("support")
                    ?
                    <th>Трейдер</th>
                    :
                    null
                }

                <th>ФИО</th>
                {store.user.roles.includes("trader")
                    ?
                    <th>Токен</th>
                    :
                    null
                }

                <th>Банк</th>
                <th>Траффик</th>
                <th>Номер</th>
                {/*{store.user.roles.includes("support")*/}
                {/*    ?*/}
                <th>Устройство</th>
                {/*    :*/}
                {/*    null*/}
                {/*}*/}
                <th className={"fixed-table-width"}>Активность</th>
                {/*{store.user.roles.includes("trader")*/}
                {/*    ?*/}
                <th className={"fixed-table-width"}>Статистика</th>
                {/*    :*/}
                {/*    null*/}
                {/*}*/}

                {/*{!store.user.agent*/}
                {/*    ?*/}
                    <th className={"fixed-table-width"}>Управление</th>
                 {/*    :*/}
                 {/*    null*/}
                 {/*}*/}


            </tr>
            </thead>
            <tbody>
            {sortedCards.map((card, index) => {


                const percent = parseFloat(((card.reminderOfLimit / card.dayLimit) * 100).toFixed(1));


                const getColor = (percent) => {
                    if (percent < 20) return '#F28B82'; // Нежный красный
                    if (percent < 50) return '#FDD663'; // Нежный жёлтый
                    return '#81C995'; // Нежный зелёный
                };

                return (
                    <tr key={card._id} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                        {store.user.roles.includes("support")
                            ?
                            <td>{card.user?.login}</td>
                            :
                            null
                        }
                        <td>{store.user.admin
                            ?
                            <button
                                onClick={() => handleCopy(card._id, index)}
                                style={{"marginRight": "5px"}}
                            > {copiedIndex === index ? 'Copied' : 'Copy ID'}</button>
                            :
                            null
                        }
                            {card.cardholder}</td>
                        {store.user.roles.includes("trader")
                            ?
                            <td>
                                {card.token
                                    ?
                                    card.group
                                        ?
                                        `Карта привязана к группе ${card.group.name ? `"${card.group.name}"` : "" }`
                                        :
                                        <button
                                            className="gradient-orange-button qr-token-btn"
                                            onClick={() => {



                                                console.log(card)
                                                setQrData(card.token?.token)
                                                setQrName(card.cardholder + "\n" + card.token?.token)
                                                // setActiveModalQr("progress")
                                                // setTimeout(() => {
                                                //     setActiveModalQr("active")
                                                // }, 300)
                                            }}
                                        >
                                            Токен
                                        </button>
                                    :
                                    null
                                }
                                {/*<span>{card.token?.token}</span>*/}

                            </td>
                            :
                            null
                        }
                        <td>{card.bank}</td>
                        <td>{card.trafficType}</td>
                        <td title={card.number}>{card.number ? "*" + card.number?.slice(-4) : "нет"}</td>
                        {/*{store.user.roles.includes("support")*/}
                        {/*    ?*/}
                        <td>
                            {card.device?.online || card.isOnline
                                ?
                                <div className={"green-bold"}>OnLine</div>
                                :
                                // !card.device?.workStatus
                                //     ?
                                card.device && !card.isOnline && !card.webHook
                                    ?
                                    <div className={"red-bold"}>OffLine</div>
                                    :
                                    card.webHook
                                        ?
                                        <div className={"green-bold"}>WebHook</div>
                                        :
                                        <div className={"red-bold"}>Не привязано</div>


                            }
                        </td>
                        {/*    :*/}
                        {/*    null*/}
                        {/*}*/}
                        <td>
                            {store.user.roles.includes("trader")
                                ?
                                card.stopByFails
                                    ?
                                    card.test
                                        ?
                                        "⚠️ На тесте"
                                        :
                                        "⚠️ Остановлена системой"
                                    :
                                    card.stopByAdmin
                                        ?
                                        "⚠️ Остановлена админом"
                                        :
                                        card.active
                                            ?
                                            card.device?.online
                                                ?
                                                card.reminderOfLimit < card.min
                                                    ?
                                                    <span
                                                        title={"Эта карта больше не получит заявок, так как ее минимальный разрешенный платеж превышает ее суточный остаток"}>
                                                                    ⚠️ - не работает</span>
                                                    :
                                                    card.maxDailyOrders > 0 && card.maxDailyOrders < card.todaysOrdersCount
                                                        ?
                                                        <span
                                                            title={"Эта карта больше не получит заявок, так как достигнут её суточный лимит заявок"}>
                                                                    ⚠️ - не работает</span>
                                                        :
                                                        <div className={"green-bold"}>В работе</div>
                                                :
                                                card.webHook
                                                    ?
                                                    <div className={"green-bold"}>В работе</div>
                                                    :
                                                    <div className={"red-bold"}>Ожидание соединения</div>
                                            :
                                            !card.activeGroup
                                                ?
                                                <div className={"red-bold"}>Остановлена группа</div>
                                                :
                                                <div className={"red-bold"}>Остановлена</div>
                                :
                                card.active && !card.stopByFails
                                    ?
                                    card.stopByAdmin
                                        ?
                                        "⚠️ Остановлена админом"
                                        :
                                        card.device?.online
                                            ?
                                            card.user?.active
                                                ?
                                                card.reminderOfLimit < card.min
                                                    ?
                                                    <span
                                                        title={"Эта карта больше не получит заявок, так как ее минимальный разрешенный платеж превышает ее суточный остаток"}>
                                                                    ⚠️ - не работает</span>
                                                    :
                                                    card.maxDailyOrders > 0 && card.maxDailyOrders < card.todaysOrdersCount
                                                        ?
                                                        <span
                                                            title={"Эта карта больше не получит заявок, так как достигнут её суточный лимит заявок"}>
                                                                    ⚠️ - не работает</span>
                                                        :
                                                        <div className={"green-bold"}>В работе</div>
                                                :
                                                <div className={"red-bold"}>Трейдер отключён</div>
                                            :
                                            card.webHook
                                                ?
                                                card.user?.active
                                                    ?
                                                    <div className={"green-bold"}>В работе</div>
                                                    :
                                                    <div className={"red-bold"}>Трейдер отключён</div>
                                                :
                                                <div className={"red-bold"}>Ожидание соединения</div>

                                    :
                                    card.stopByFails
                                        ?
                                        card.test
                                            ?
                                            <div>
                                                ⚠️ На тесте
                                                <button
                                                    onClick={() => activateCardWithoutTest(card._id, index)}
                                                    className={"gradient-green-button"}>Вкл.</button>
                                            </div>
                                            :
                                            <div>
                                                ⚠️ Остановлена системой
                                                <button
                                                    onClick={() => activateCardWithoutTest(card._id, index)}
                                                    className={"gradient-green-button"}>Вкл.</button>
                                            </div>

                                        :
                                        "⚠️ Остановлена трейдером"

                            }

                        </td>

                        {/*{store.user.roles.includes("trader")*/}
                        {/*    ?*/}
                        <td>
                            {card.stopByFails
                                ?
                                card.test
                                    ?
                                    card.test.numberAmount > 1
                                        ?
                                        `Ждем перевод ${card.test.numberAmount}р. по номеру карты`
                                        :
                                        card.test.sbpAmount
                                            ?
                                            <>
                                                {card.test.numberAmount === 1 ?
                                                    <span>По номеру ОК<img height={"15px"}
                                                                           src={OKSvg}/><br/><br/></span> : ""}
                                                Ждем перевод {card.test.sbpAmount}р. {
                                                card.trafficType === "nspk"
                                                    ?
                                                    "по QR-коду"
                                                    :
                                                    card.trafficType === "applink_vtb"
                                                        ?
                                                        ""
                                                        :
                                                        "по СБП"
                                            }
                                            </>
                                            :
                                            null
                                    :
                                    store.user.roles.includes('trader')
                                        ?
                                        card.device || card.webHook
                                            ?
                                            <button
                                                className={"gradient-green-button"}
                                                onClick={
                                                card.dynamicType
                                                    ?
                                                    () => {
                                                        store.setCardToEditId(card._id)
                                                        navigate('/create_card')

                                                    }
                                                    :
                                                    () => startCardTest(card._id)
                                            }
                                            >Тестировать</button>
                                            :
                                            "⚠️ Сначала привяжите устройство"
                                        :
                                        card.test
                                            ?
                                            "⚠️ На тесте"
                                            :
                                            "⚠️ Ожидает тестирования"
                                :
                                <div>
                                    <div className="limit-bar">
                                        <div
                                            className="limit-fill"
                                            style={{
                                                width: `${percent}%`,
                                                backgroundColor: getColor(percent),
                                            }}
                                        ></div>
                                        <div className="limit-text">
                                            {addDevidersToString(card.reminderOfLimit?.toFixed(2))}
                                        </div>
                                    </div>
                                    <div className={"card-info-mini"}>В
                                        день: {card.todaysOrdersCount}/{!card.maxDailyOrders || card.maxDailyOrders === 0 ? "∞" : card.maxDailyOrders}</div>
                                    <div
                                        className={"card-info-mini"}>Интервал: {card.intervalBetweenTransactions ? card.intervalBetweenTransactions + " м." : "нет"}</div>
                                    <div
                                        className={"card-info-mini"}>Одновременно: {card.limitOfOpened ? card.limitOfOpened : "∞"}</div>
                                    <div className={"card-info-mini"}>Чеки от {card.min} до {card.max} р.</div>

                                </div>

                                // `${card.reminderOfLimit}/${card.dayLimit}`
                                // <img height={"30px"} src={OKSvg}/>
                            }

                        </td>
                        {/*//     :*/}
                        {/*//     null*/}
                        {/*// }*/}




                        {/*{!store.user.agent*/}
                        {/*    ?*/}
                            <td>
                                <div className={"flex-table-cell-column"}>
                                    <div className={"flex-table-cell"}>
                                        {/*{card.isEditable || store.user.roles.includes('support')*/}
                                        {/*    ?*/}
                                        <button
                                            className={"gradient-orange-button"}
                                            onClick={() => {
                                                store.setCardToEditId(card._id)
                                                navigate('/create_card')

                                            }}
                                        >Изменить {
                                            processing.status && processing.index === index
                                                ?
                                                <img src={require('../../img/loading.gif')} height={"15px"}
                                                     className={"margin-left-20"}/>
                                                :
                                                null
                                        }
                                        </button>
                                        {/*    :*/}
                                        {/*    null*/}
                                        {/*}*/}

                                        {store.user.roles.includes("support")
                                            ?
                                            !card.stopByAdmin
                                                ?
                                                <button
                                                    className={"gradient-red-button"}
                                                    onClick={() => {

                                                        changeCardStatus(card._id, index)

                                                    }}
                                                >Отключить{
                                                    processing.status && processing.index === index
                                                        ?
                                                        <img src={require('../../img/loading.gif')} height={"15px"}
                                                             className={"margin-left-20"}/>
                                                        :
                                                        null
                                                }
                                                </button>
                                                :
                                                <button
                                                    className={"gradient-green-button card-status-switch-btn"}
                                                    onClick={() => {

                                                        changeCardStatus(card._id, index)
                                                    }}
                                                >Включить {processing.status && processing.index === index ?
                                                    <img src={require('../../img/loading.gif')} height={"15px"}
                                                         className={"margin-left-20"}/> : null}</button>

                                            :
                                            card.active
                                                ?
                                                <button
                                                    className={"gradient-red-button"}
                                                    onClick={() => {

                                                        changeCardStatus(card._id, index)

                                                    }}
                                                >Отключить{
                                                    processing.status && processing.index === index
                                                        ?
                                                        <img src={require('../../img/loading.gif')} height={"15px"}
                                                             className={"margin-left-20"}/>
                                                        :
                                                        null
                                                }
                                                </button>
                                                :
                                                card.activeGroup
                                                    ?
                                                    <button
                                                        className={"gradient-green-button card-status-switch-btn"}
                                                        onClick={() => {

                                                            changeCardStatus(card._id, index)
                                                        }}
                                                    >Включить {processing.status && processing.index === index ?
                                                        <img src={require('../../img/loading.gif')} height={"15px"}
                                                             className={"margin-left-20"}/> : null}</button>
                                                    :
                                                    card.group
                                                        ?
                                                        null
                                                        :
                                                        <button
                                                            className={"gradient-green-button card-status-switch-btn"}
                                                            onClick={() => {

                                                                changeCardStatus(card._id, index)
                                                            }}
                                                        >Включить {processing.status && processing.index === index ?
                                                            <img src={require('../../img/loading.gif')} height={"15px"}
                                                                 className={"margin-left-20"}/> : null}</button>

                                        }


                                    </div>
                                    <div className={"flex-table-cell"}>
                                        {card.device && store.user.roles.includes("trader")
                                            ?
                                            <button
                                                className={"gradient-orange-button"}
                                                onClick={() => {

                                                    if (card.group) {
                                                        setModalMessage(`Вы действительно хотите отвязать карту ${card.number}\n${card.cardholder} от устройства?\nКарта также будет исключена из группы`)
                                                    } else {
                                                        setModalMessage(`Вы действительно хотите отвязать карту ${card.number}\n${card.cardholder} от устройства?`)
                                                    }

                                                    setCardToDelete()
                                                    setCardToUnbind(card._id)
                                                    setActiveModalConfirm("progress")
                                                    setTimeout(() => {
                                                        setActiveModalConfirm("active")
                                                    }, 100)
                                                }}
                                            >Отвязать
                                            </button>
                                            :
                                            null
                                        }
                                        {store.user.roles.includes("trader")
                                            ?
                                            <button
                                                className={"gradient-dark-button"}
                                                onClick={() => {

                                                    setModalMessage(`Вы действительно хотите удалить карту ${card.number}\n${card.cardholder}`)
                                                    setCardToUnbind()
                                                    setCardToDelete(card._id)
                                                    setActiveModalConfirm("progress")
                                                    setTimeout(() => {
                                                        setActiveModalConfirm("active")
                                                    }, 100)
                                                }}
                                            >Удалить
                                            </button>
                                            :
                                            null
                                        }

                                    </div>
                                </div>

                            </td>
                        {/*    :*/}
                        {/*    null*/}
                        {/*}*/}


                    </tr>
                );
            })}
            </tbody>
        </table>
    );
};

export default CardViewerTable;